import React, { useEffect, useState } from 'react';
import { useOrdersQuery, useStatusQuery } from '../../Store/Apis/bookingApi'
import Error from '../../Components/Error/Error'
import Loader from '../../Components/Loader/Loader'
import { Link } from 'react-router-dom'
import { useOutletsQuery } from '../../Store/Apis/outletApi'
import getStatusColor from '../../Hooks/GetStatusColor'
import { isDropdownPermission, isPermissionGranted } from '../../Hooks/permissionsMiddleware'
import { Table, Badge } from 'antd';
import { Modal } from 'react-bootstrap'
import AddPaymentForm from '../../Components/AddPaymentForm/AddPaymentForm'
import { useSelector } from 'react-redux'
import formatDate from '../../Hooks/formatDate'
import { useRolesQuery } from '../../Store/Apis/rolePermissionApi'


const StockApproval = () => {
    const user = useSelector((state) => state.auth.user)
    const [sortFilter, setSortFilter] = useState({
        search: '',
        outlet: '',
        status: '',
        technicianID: ''
    });

    const bookingApi = useOrdersQuery({
        keyword: sortFilter.search,
        statusName: sortFilter.status,
        AdminID: user.id
    })

    const outletList = useOutletsQuery()
    const statusList = useStatusQuery() 
    const roleApi = useRolesQuery()


    // Define columns for the Ant Design Table
    const columns = [
        {
            title: 'Order Info',
            dataIndex: 'orderInfo',
            fixed: 'left',
            width: 250,
            render: (_, record) => (
                <>
                    <p className="text-sm mb-0">
                        <span className="me-2">Order ID:</span>
                        <span className="font-weight-bold">{record.orderNumber}</span>
                    </p>
                    {/* <p className="text-sm mb-0">
                        <span className="me-2">Check-in Date:</span>
                        <span>{formatDate(record.orderDate)}</span>
                    </p>
                    <p className="text-sm mb-0">
                        <span className="me-2">Check-out Date:</span>
                        <span>{formatDate(record.orderDate)}</span>
                    </p> */}
                    <p className="text-sm mb-0">
                        <span className="me-2">Order Date:</span>
                        <span>{formatDate(record.orderDate)}</span>
                    </p>
                </>
            ),
        },
        {
            title: 'Outlet',
            dataIndex: 'outletName',
        },
        {
            title: 'Customer',
            dataIndex: 'customer',
            render: (_, record) => (
                <>
                    <p className="text-sm font-weight-bold mb-0">{record.customerName}</p>
                    <p className="text-sm mb-0">{record.customerNumber}</p>
                </>
            ),
        },
        {
            title: 'Order Amount',
            dataIndex: 'subTotal',
            render: (subTotal) => `R ${subTotal}`,
        },
        {
            title: 'Status',
            dataIndex: 'statusDescription',
            render: (status) => (
                <span
                    className={`badge badge-sm text-uppercase badge-${getStatusColor(status === 'Approved'? 'Completed' : status)}`}
                    style={{ cursor: "default" }}
                >
                    {status}
                </span>
            ),
        },
        {
            title: 'Payment',
            dataIndex: 'payment',
            render: (_, record) => (
                <>
                    <p className="text-sm mb-0">
                        <span className="me-2">Total Amount:</span>
                        <span className="font-weight-bold">R {record.subTotal}</span>
                    </p>
                    <p className="text-sm mb-0">
                        <span className="me-2">Paid Amount:</span>
                        <span className="font-weight-bold">R {record.amountPaid}</span>
                    </p>
                </>
            ),
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            render: (_, record) => <p className="text-sm mb-0">{record.customerName}</p>,
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            fixed: 'right',
            width: 150,
            render: (_, record) => (
                <>
                    <Link
                        to={`/stock-approval/details?id=${record.orderId}`}
                        className="badge badge-xs badge-primary text-xs fw-600 mx-1"
                    >
                        View
                    </Link>
                </>
            ),
        },
    ];

    // Transform data to fit the Ant Design table structure
    const dataSource = bookingApi?.data?.data?.map((elem, index) => ({
        key: index,
        orderNumber: elem.orderNumber,
        orderDate: elem.orderDate,
        outletName: elem.outletName,
        customerName: elem.customerName,
        customerNumber: elem.customerNumber,
        subTotal: Number((elem.subTotal + elem.taxAmount) - elem.discount).toFixed(2),
        statusDescription: elem.approvalStatusName,
        amountPaid: Number(elem.amountPaid).toFixed(2),
        totalAmount: Number(elem.totalAmount).toFixed(2),
        orderId: elem.orderId,
        createdBy: elem.createdBy,
    }));
    

    useEffect(() => {
        if (user.role !== 'superAdmin') {
            setSortFilter({
                ...sortFilter,
                outlet: user.outletID,
            });
        }
        if(roleApi.isSuccess && user.role === 'Technician'){
            const technicianRole = roleApi.data?.data?.find((elem) => elem.roleName === 'Technician');
            setSortFilter({
                ...sortFilter,
                technicianID: technicianRole?.roleID === user.role_Id ? user.id : ''
            });
        }
    }, [roleApi.isSuccess]);


    return (
        <div>
            <div className="row align-items-center justify-content-between mb-4">
                <div className="col">
                    <h5 className="fw-500 text-white mb-0">Internal Stock Requests</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card mb-4">
                        <div className="card-header p-4">
                            <div className="row">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Order Id, Outlet and Customer"
                                        value={sortFilter?.search || ""}
                                        onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <select 
                                        className="form-select" 
                                        disabled={!outletList.isSuccess || !isDropdownPermission(user.role_Id)}
                                        value={sortFilter?.outlet}
                                        onChange={(e) => setSortFilter({...sortFilter, outlet: e.target.value})}
                                    >
                                        <option className="select-box" value="">
                                            All Outlets
                                        </option>
                                        {
                                            outletList?.data?.data.map((elem)=>{
                                                return(
                                                    <option value={elem.outletId}>{elem.outletName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <select 
                                        className="form-select"
                                        value={sortFilter?.status || ""}
                                        onChange={(e) => setSortFilter({...sortFilter, status: e.target.value})}    
                                    >
                                        <option className="select-box" value="">
                                            All Bookings
                                        </option>
                                        {
                                            statusList?.data?.data.map((elem, i) => {
                                                return <option className="select-box" value={elem.description}>{elem.description}</option>
                                            })
                                        }                                        
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            {bookingApi.isError && <Error/>}
                            {bookingApi.isLoading && <Loader height="500px"/>}
                            {
                                bookingApi.isSuccess && (
                                    <Table
                                        columns={columns}
                                        dataSource={dataSource}
                                        pagination={{ pageSize: 10 }}
                                        className="mx-4"
                                        scroll={{ x: 1500 }}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default StockApproval;
